import type { Discussion } from '@/types'

/**
 * Daily Call Report (DCR) helpers.
 *
 * A DCR entry IS a discussion logged against a Lead or Customer — so DCRs and
 * the Lead/Customer Discussion History stay in sync automatically (one source
 * of truth). These constants map the DCR "Contact Type" to the discussion type.
 */

export type DcrContactType = 'WhatsApp' | 'Email' | 'SMS' | 'Phone Call' | 'Direct Visit' | 'Video Call'

export const DCR_CONTACT_TYPES: DcrContactType[] = [
  'WhatsApp', 'Email', 'SMS', 'Phone Call', 'Direct Visit', 'Video Call',
]

export const DCR_CUSTOMER_STATUSES = [
  'Interested', 'Negotiating', 'Follow-up Required', 'Converted', 'Not Interested', 'No Response',
]

/** DCR Contact Type → Discussion.type */
export const contactToDiscType: Record<DcrContactType, Discussion['type']> = {
  'WhatsApp': 'whatsapp',
  'Email': 'email',
  'SMS': 'sms',
  'Phone Call': 'call',
  'Direct Visit': 'visit',
  'Video Call': 'video',
}

/** Discussion.type → human label used in the DCR list (Contact Type column) */
export const discTypeToContact: Record<string, string> = {
  whatsapp: 'WhatsApp',
  email: 'Email',
  sms: 'SMS',
  call: 'Phone Call',
  visit: 'Direct Visit',
  video: 'Video Call',
  note: 'Note',
  expomeet: 'Expomeet Visit',
}

export const contactTypeColor: Record<string, string> = {
  WhatsApp: '#25D366', Email: '#2563EB', SMS: '#0891B2',
  'Phone Call': '#D97706', 'Direct Visit': '#0D9488', 'Video Call': '#7C3AED',
  Note: '#6B7280', 'Expomeet Visit': '#9333EA',
}
